import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { getUserPreference } from "../../../utilities/common";
import { getDispatchListHistory, getDriverDropoffHistory, getDriverDispatchBetween, getDriverDispatchById, getScanBatchReports, handleDriverIdSearch } from '../../../actions/ddActions';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { useTranslation } from 'react-i18next';
import FullscreenLoading from "../../Common/FullscreenLoading";
import { showAlertSnackbar } from "../../../reducers/uiSlice";

const useStyles = makeStyles((theme) => ({
    containerStyle: { 
        display: "flex", 
        alignItems: "baseline",
        marginTop: 10        
    },
    spanStyle: { 
        display: "inline-block", 
        padding: '0 20px', 
        paddingTop: '5px' 
    },
    textFieldStyle: { 
        marginLeft: '20px', 
        width: 100 
    },
    buttonStyle: { 
        padding: '10px 10px', 
        marginLeft: 20 
    }
}));

function ConditionalSearch(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('driverDispatch');
    const userPref = getUserPreference();

    const driverPackageFeatures = [
        {
            name: t('pickup_scan_report'),
            id: 3,
            type: 'pickup_scan_report'
        },
        {
            name: t('driver_dispatch_new'),
            id: 2,
            type: 'driver_dispatch_new'
        },
        {
            name: t('driver_dropoff'),
            id: 1,
            type: 'driver_dropoff'
        }
    ]

    const [dateFrom, setDateFrom] = useState(moment().format('YYYY-MM-DD'));
    const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchType, setSearchType] = useState(3);
    const [driverId, setDriverId] = useState(null);

    async function handleDateQuery(dateFrom, dateTo) {
        setDisabled(true);
        setLoading(true);
        const dateFromNum = moment(dateFrom).startOf('day').valueOf() / 1000;;
        const dateToNum = Math.floor(moment(dateTo).endOf('day').valueOf() / 1000);
        let paramsDateNum= {
            start_time: dateFromNum,
            end_time: dateToNum,
            warehouse: userPref.userCity
        }
        let paramsDateStr = {
            warehouse: userPref.userCity,
            start_date: dateFrom,
            end_date: dateTo,
            driver_id: driverId
        }
        let paramsNoDate = {
            warehouse: userPref.userCity,
            driver_id: driverId
        }
        dispatch(handleDriverIdSearch(driverId));
        try {
            if(searchType === 0) {
                await dispatch(getDriverDispatchBetween(paramsDateNum))
            } else {
                if(searchType === 1) {
                    await dispatch(getDriverDropoffHistory(paramsDateNum))
                } else if(searchType === 2) {
                    await dispatch(getDispatchListHistory(paramsDateStr))
                } else if(searchType === 3) {
                    await dispatch(getScanBatchReports(paramsNoDate));
                }
            }
            props.handleSearchContent(dateFrom, dateTo, '');
        } catch(err) {
            dispatch(showAlertSnackbar({message: t('fail_search'), type: 'error'}))
        } finally {
            setDisabled(false);
            setLoading(false);
        }
    }

    useEffect(() => {
        let searchTypeObj = driverPackageFeatures.find(element => element.id === searchType);
        props.handleSearchType(searchTypeObj.type);
    }, [searchType])

    return (
        <Grid
            container
            alignItems="center"
            justify="center"
            className={classes.containerStyle}
        >
            <Grid item xs={3} style={{display:'flex', alignItems: 'center', padding: 16, textAlign: 'center'}}>
                <TextField 
                    fullWidth
                    select
                    label={t('driver_query')}
                    size="small"
                    variant="outlined"
                    value={searchType}
                    onChange={(e)=>setSearchType(e.target.value)}
                >
                {
                    driverPackageFeatures.map((feature) => (
                        <option key={feature.id} value={feature.id}>
                            {feature.name}
                        </option>
                    ))
                }
                </TextField>
            </Grid>
            <Grid item xs={9} style={{display:'flex', alignItems: 'center', padding: 16, textAlign: 'center'}}>
                {
                    searchType !== 3 &&
                    <div style={{display:'flex', alignItems: 'center', padding: 16, textAlign: 'center'}}>
                        <TextField 
                            size="small"
                            id="driverdispatch-startdatesearch-textfield"
                            type="date"
                            variant="outlined"
                            value={dateFrom}
                            onChange={(e)=>setDateFrom(e.target.value)}
                        />        
                        <span className={classes.spanStyle}>{t('to')}</span>
                        <TextField 
                            size="small"
                            id="driverdispatch-enddatesearch-textfield"
                            type="date"
                            variant="outlined"
                            value={dateTo}
                            onChange={(e)=>setDateTo(e.target.value)}
                        />
                    </div>
                }
                {
                    searchType !== 1 &&
                    <div style={{display:'flex', alignItems: 'center', padding: 16, textAlign: 'center'}}>
                        <TextField 
                            label={t('driver_id')}
                            size="small"
                            id="driverdispatch-driveridsearch-textfield"
                            variant="outlined"
                            value={driverId}
                            onChange={(e)=>setDriverId(e.target.value)}
                        />
                    </div>
                }
                <div style={{display:"flex",alignItems:"center"}}>
                    <Button
                        id="driverdispatch-search-button"
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                            handleDateQuery(dateFrom, dateTo);
                        }}
                        className={classes.buttonStyle}
                        disabled={disabled}
                    >
                        {t('common:search')}
                    </Button>
                </div>
            </Grid>
            <FullscreenLoading open={loading} />
        </Grid>
    );
}
export default ConditionalSearch;